import { Text } from 'src/design/atoms/Text';
import { MRT_ColumnDef } from 'mantine-react-table';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { JobDto } from 'src/api/FiretrolApiClient';
import { useServiceJobs } from 'src/api/queries/serviceJobs/useServiceJobs';
import { ViewActionIcon } from 'src/design/atoms/ViewActionIcon';
import {
  useTable,
  useTableState,
} from 'src/design/organisms/DataTable/useTable';

const EMPTY_JOBS: JobDto[] = [];

export const AllWorkTab: React.FC = () => {
  const navigate = useNavigate();
  const { data: jobs = EMPTY_JOBS, isLoading } = useServiceJobs();

  const handleView = (row: JobDto) => {
    navigate(`/jobs/${row.id}/summary`);
  };

  const columns = React.useMemo<MRT_ColumnDef<JobDto>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Job',
        size: 300,
      },
      {
        id: 'serviceUser',
        accessorFn: (row) => row.serviceUser?.fullName || '--',
        header: 'Service Technician',
        size: 200,
      },
      {
        id: 'serviceOffice',
        accessorFn: (row) => row.serviceOffice?.name || '--',
        header: 'Office',
        size: 150,
      },
      {
        id: 'description',
        accessorFn: (row) =>
          row.description && row.description.length > 0
            ? row.description
            : '--',
        header: 'Description',
        size: 300,
        Cell: ({ cell }) => (
          <Text
            c="black"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {cell.getValue<string>()}
          </Text>
        ),
      },
    ],
    [],
  );

  const tableState = useTableState({
    identifier: 'service-jobs-table',
    columns: columns,
    defaultSorting: [{ id: 'job', desc: false }],
  });

  const { table } = useTable({
    ...tableState,
    tableOptions: {
      enableRowActions: true,
      displayColumnDefOptions: { 'mrt-row-actions': { size: 100 } },
      renderRowActions: ({ row }) => (
        <ViewActionIcon onClick={() => handleView(row.original)} />
      ),
      enableClickToCopy: false,
      columns: columns,
      data: jobs,
      manualPagination: false,
      manualSorting: false,
      manualFiltering: false,
    },
    getRowId: (row) => String(row.id),
    totalCount: jobs.length,
    isLoading,
    isFetching: false,
    isError: false,
    toolbarExportCsvOptions: {
      enabled: true,
      filename: 'service-jobs',
      transform: (data) => {
        return data.map((item) => ({
          ['Job Number']: item.jobNumber,
          ['Job Name']: item.name,
          ['Service User']: item.serviceUser?.fullName || '',
          ['Office']: item.serviceOffice?.name || '',
          ['Description']: item.description || '',
        }));
      },
    },
  });

  return table;
};
